export default __webpack_public_path__ + "static/media/Clínica-Guaiba.fc0d6489.png";